import { render, staticRenderFns } from "./EmployeesTable.vue?vue&type=template&id=6cb7544a&scoped=true&"
import script from "./EmployeesTable.vue?vue&type=script&lang=ts&"
export * from "./EmployeesTable.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeesTable.vue?vue&type=style&index=0&id=6cb7544a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7544a",
  null
  
)

export default component.exports